"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Spacer = void 0;
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var clsx_1 = __importDefault(require("clsx"));
var SpacerRender = function (props, ref) {
    var children = props.children, classes = props.classes, flex = props.flex, height = props.height, style = props.style, width = props.width, otherDivProps = __rest(props, ["children", "classes", "flex", "height", "style", "width"]);
    return (react_1.default.createElement("div", __assign({ ref: ref, "data-test": 'spacer-root', className: clsx_1.default(classes.root), style: Object.assign({
            flex: flex + " " + flex + " " + (flex === 0 ? 'auto' : '0px'),
            height: height || 'auto',
            width: width || 'auto',
        }, __assign({}, style)) }, otherDivProps), children));
};
/**
 * [Spacer](https://pxblue-components.github.io/react/?path=/info/components-spacer--get-read-me-story) component
 *
 * An invisible utility component that acts as a spacer element in various layouts. It works with flexbox sizing or fixed sizing.
 */
exports.Spacer = react_1.default.forwardRef(SpacerRender);
exports.Spacer.displayName = 'Spacer';
exports.Spacer.propTypes = {
    flex: prop_types_1.default.number,
    width: prop_types_1.default.number,
    height: prop_types_1.default.number,
    classes: prop_types_1.default.shape({
        root: prop_types_1.default.string,
    }),
};
exports.Spacer.defaultProps = {
    flex: 1,
    classes: {},
};
